
(function () {
    'use strict';

    class CalendlyIntegrationComponent extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, ModalService, UsersManager, PopupMessageService, $timeout) {
            super($scope, $injector);
            this.__objectType = 'ProjectDetailsFieldVisibility';

            this.ModalService = ModalService;
            this.UsersManager = UsersManager;
            this.PopupMessageService = PopupMessageService;
            this.$timeout = $timeout;

            this.isLoading = false;
            this.publicLink = '';
            this.userIsSubscribeToCalendly = false;
        }

        $onInit() {

            // get calendly public link
            this.getCalendlyPublicLink();

        }

        getCalendlyPublicLink() {
            this.isLoading = true;
            this.UsersManager.getCalendlyPublicLink(this.userModel).then(function success(resp) {

                // set connected flag
                this.userIsSubscribeToCalendly = !!resp.data.public_link;

                //  generate link if connected
                if (this.userIsSubscribeToCalendly) {
                    this.publicLink = this.generatePublicLink(resp.data.public_link, this.userModel);
                }

            }.bind(this)).finally(function final() {
                this.isLoading = false;
            }.bind(this));
        }

        connect() {
            this.ModalService.openCalendlyAddApiKeyModal()
                .then(function success() {
                    this.getCalendlyPublicLink();
                }.bind(this));
        }

        generatePublicLink(calendlyLink, user) {
            return calendlyLink + "?utm_source=honeybook&utm_content=company-" + user.company._id + "-" + user._id;
        }

        disconnect() {
            this.PopupMessageService.showConfirmPromise(
                this.PopupMessageService.severityTypes.warning,
                'Are you sure you want to disconnect?',
                'DISCONNECT','CANCEL', 'Disconnect Calendly').then(function yes() {
                this.confirmDisconnectFromCalendly();
            }.bind(this));
        }

        confirmDisconnectFromCalendly() {
            this.isLoading = true;
            this.UsersManager.deleteCalendlysubscription(this.userModel)
                .then(function success() {
                    this.UsersManager.forceFetchCurrUser();
                    this.userIsSubscribeToCalendly = false;
                }.bind(this))
                .finally(function () {
                    this.isLoading = false;
                }.bind(this));
        }

        onPublicLinkClick ($event) {
            $event.target.select();
        }

        onCopyLinkClick() {
            this.copying = true;
            this.$timeout(function() {
                this.copying = false;
            }.bind(this), 5000);
        }

    }

    Components.CalendlyIntegration = {
        bindings: {
            userModel: '<'
        },
        controller: CalendlyIntegrationComponent,
        controllerAs: 'calendlyIntegrationVm',
        name: 'hbCalendlyIntegration',
        templateUrl: 'angular/app/modules/core/features/settings/company/integrations/calendly/calendly_integration.html'
    };

}());